﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_cartList from './tpl/cartList.html';
import View_CartListItem from './cartListItem';

export default Marionette.CollectionView.extend({
    //tagName: 'tbody',
    //className :'myrow',
    //childViewContainer: '#cartList',
    childView: View_CartListItem,
    getTemplate: function () {
        return tpl_cartList();
    },
    onRender: function () {
    },
    initialize: function () {
        this.app = this.options.app;
        this.listenTo(this.collection, 'change', this.render);
    },
    buildChildView: function(child, ChildViewClass, childViewOptions){
        var options = _.extend({model: child}, childViewOptions);
        options.app = this.app;
        var view = new ChildViewClass(options);
        return view;
    }
});
